import { render, staticRenderFns } from "./LineaTiempoB.vue?vue&type=template&id=67dab17c&scoped=true&lang=pug&"
import script from "./LineaTiempoB.vue?vue&type=script&lang=js&"
export * from "./LineaTiempoB.vue?vue&type=script&lang=js&"
import style0 from "./LineaTiempoB.vue?vue&type=style&index=0&id=67dab17c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dab17c",
  null
  
)

export default component.exports